import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { RxCrossCircled } from 'react-icons/rx';
import httpCommon from 'src/http-common';
import {
  FormControl,
  InputLabel,
  Input,
  Paper,
  DialogTitle,
  Dialog,
} from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';

import { useRouter } from 'src/routes/hooks';
import FormProvider, { RHFTextField } from 'src/components/hook-form';

import Iconify from 'src/components/iconify';

import LoderImg from './Spain_loderImg.gif';
// import '../../../style.css';

// ----------------------------------------------------------------------

export default function InProgressStatus({ selectedRowID }) {


  const router = useRouter();
  const url = httpCommon.defaults.baseURL;
  const getId = localStorage.getItem('ww_emp_mst_empl_id');
  const getHsp = localStorage.getItem('ww_Hsp'); // site_cd

  const SelectedUserId = selectedRowID; // UserId

  const [UserDt, setUserDt] = useState([]);
  const [imageData, setImageData] = useState('');
  const [UserDtImg, setUserDtImg] = useState([]);

  const [UserInfoData, setUserInfoData] = useState([]);
  const [phnNo, setPhnNo] = useState('');
  const Username = UserInfoData?.wkr_mst_requestor || '';
  const userdept = UserInfoData?.wkr_mst_dept || '';
  const [imageDialog, setImageDialog] = useState(false);
  const [empl,setEmpl] = useState("")
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [department, setDepartment] = useState('');
  const [FilledFormData, setFilledFormData] = useState({
    workArea: ' ',
    level: ' ',
    assetLocation: ' ',
    assetNumber: ' ',
    workGroup: ' ',
    originalProperty: ' ',
    faultyCode: ' ',
    workDescription: ' ',
    workOrderNo: ' ',
    workOrdeStatus: ' ',
    image: ' ',
    workCorrective: ' ',
  });
  // Get Api All Data
  useEffect(() => {
    setLoading(true);
    const fetchUserWorkListData = async () => {
      console.log('getId', getId);
      console.log('getId', getHsp);
      console.log('SelectedUserId', SelectedUserId);

      try {
        const response = await httpCommon.get(
          `/InProgressStatus.php?id=${getId}&siteCd=${getHsp}&UserId=${SelectedUserId}`
        );
        console.log('response_Inprogress', response);
        if (response.data.status === 'SUCCESS') {
          setTimeout(()=>{
            setLoading(false)
          },1000)
          if (response.data) {
            const data = response.data.data1?.[0]; // Using optional chaining to avoid TypeError
            setUserDtImg(response.data.data1);
            setFilledFormData((pre) => ({
              ...pre,
              workOrderNo: data && data.wko_mst_wo_no ? data.wko_mst_wo_no : '',
              workOrdeStatus: data && data.wko_mst_status ? `${data.wko_mst_status} : ${data.wrk_sts_desc}`  : '',
              workCorrective: data && data.wko_det_corr_action  ? data.wko_det_corr_action : '',
              image: data ? data.attachment
               : '',               
              file_name:data ? data.file_name
              
               : ''

            }));
            console.log('data', data.data1);
          }
        } else {
          console.error('Response data is undefined');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchUserWorkListData(); // Call the function directly
  }, [getId, getHsp, SelectedUserId]);

  // request form
  // Fetch user Form Data Request
  useEffect(() => {
    setLoading(true);
    const fetchUserRequest = async () => {
      try {
        const response = await httpCommon.get(
          `/AllFormDataGet.php?siteCd=${getHsp}&UserId=${SelectedUserId}`
        );
        console.log('response_request', response);
        if (response.data.status === 'SUCCESS') {
          setTimeout(()=>{
            setLoading(false)
          },1000)
          setUserDt(response.data.data1);
          
          // If you want to call setFilledFormData here, uncomment the following lines
          setFilledFormData((prev) => {
            const data = response.data.data1 && response.data.data1[0];

            return {
              ...prev,
              workArea: data && data.wkr_mst_work_area ? `${data.wkr_mst_work_area} : ${data.work_area_desc}` : ' ',
              level: data && data.wkr_mst_location && data.wkr_mst_location_desc  ? `${data.wkr_mst_location} : ${data.wkr_mst_location_desc}` : ' ',
              assetLocation: data && data.wkr_mst_assetlocn && data.wkr_mst_assrtlocn_desc 
                ? `${data.wkr_mst_assetlocn} : ${data.wkr_mst_assrtlocn_desc}`
                : ' ',
              assetNumber: data && data.wkr_mst_assetno && data.wkr_mst_assetno_desc  ? `${data.wkr_mst_assetno} : ${data.wkr_mst_assetno_desc}` : '',
              workGroup: data && data.wkr_mst_work_group && data.work_group_desc ? `${data.wkr_mst_work_group} : ${data.work_group_desc}` : '  ',
              originalProperty: data && data.wkr_mst_orig_priority && data.orig_priority_desc
                ? `${data.wkr_mst_orig_priority} : ${data.orig_priority_desc}`
                : '',
              faultyCode: data && data.wkr_mst_fault_code && data.fault_code_desc  ? `${data.wkr_mst_fault_code} : ${data.fault_code_desc}` : ' ',
              workDescription: data ? data.wkr_mst_wr_descs : ' ',
            };
          });
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchUserRequest(); // Call the fetchUserRequest function here
  }, [getHsp, SelectedUserId]);

  console.log('fillformData', FilledFormData);
  // chdck setting mode
  useEffect(() => {
    document.body.classList.remove('customNav');
    const handleThemeOnLoad = () => {
      const storedValue = localStorage.getItem('dataDark');
      // console.log("storedValue++", storedValue);
      if (storedValue === 'dark') {
        document.body.classList.add('custom-darkClass');
      } else {
        document.body.classList.remove('custom-darkClass');
      }
    };
    handleThemeOnLoad();
    return () => {
      document.body.classList.remove('custom-darkClass');
    };
  }, []);

  // get all user Info
  // get UserInformation
  useEffect(() => {
    setLoading(true);
    const fetchUserInfo = async () => {
      const requestData = {
        site_cd: getHsp,
        login_id: getId,
        mst_rowID: selectedRowID,
      };

      try {
        const response = await httpCommon.post('/GetUserInfo.php', requestData);
        console.log('responseData', response);
        if (response.data.status === 'SUCCESS') {
          setTimeout(()=>{
            setLoading(false)
          },1000)

          setName(response.data.data.query1_response[0].emp_mst_name);
          setEmpl(response.data.data.query1_response[0].emp_mst_empl_id)
          setDepartment(response.data.data.query1_response[0].emp_det_department);

          setPhnNo(response.data.data.query1_response[0].emp_mst_homephone);
          setEmail(response.data.data.query1_response[0].emp_det_email_id
          );
        }
      } catch (error) {
        console.log('Error', error);
      }
    };
    fetchUserInfo();
  }, [getHsp, getId, selectedRowID]);

  useEffect(() => {
    async function fetchEmailData() {
      try {
        const response = await httpCommon.get(`getUserEmailId.php`);
      } catch (error) {
        console.log('error', error);
      }
    }
    fetchEmailData();
  }, []);

  const selectedSchema = '';

  const methods = useForm({
    resolver: yupResolver(selectedSchema),
  });

  const handleImageDialog = (ImageUrl, title) => {
    console.log('urlImg', ImageUrl);
    const newStr = title?.replace('upload//', '');
    setImageData((pre) => ({ ImageUrl, head: newStr }));
    setImageDialog(true);
  };
  const [imageError, setImageError] = useState(false);
  const [imageError2, setImageError2] = useState(false);
  const handleImageError = () => {
    setImageError(true);
  };
  const handleImageError2 = () => {
    setImageError2(true);
  };
  const formatDate = (dateString) => {
    const rawDate = new Date(dateString);
    const day = String(rawDate.getDate()).padStart(2, '0');
    const month = String(rawDate.getMonth() + 1).padStart(2, '0');
    const year = rawDate.getFullYear();
    const hours = String(rawDate.getHours()).padStart(2, '0');
    const minutes = String(rawDate.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };
  const statusText = UserDt[0]?.wko_mst_status === 'DO' ? 'In Progress' : '';
  return (
    <>
         <Dialog
        open={loading }
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={LoderImg} alt="loderImg" style={{ width: '80px' }} />
        </div>
      </Dialog>
      <FormProvider methods={methods}>
        <Grid container spacing={4} className="RejectStatusCs">
          <Grid xs={12} md={5}>
            <Card sx={{ px: 3, pb: 5 }}>
              <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }} className='flex items-center gap-2'>
                <Iconify
                  icon="codicon:git-pull-request-new-changes"
                  style={{ marginBottom: '-5px' }}
                />{' '}
                Requester Information
              </Typography>

              <Box display="flex" flexDirection="column" rowGap={3}>
                {/* <TextField id="filled-basic" label="Employee ID"  inputProps={{ className: 'RejinputClass' }} disabled variant="filled"  defaultValue={getId} /> */}

                <div className="usrFrmFld">
                  <FormControl>
                    <InputLabel>Employee ID</InputLabel>
                    <Input type="text" name="name" value={empl} disabled />
                  </FormControl>
                </div>
                <div>
                  {(() => {
                    if (name) {
                      return (
                        <div className="usrFrmFld">
                          <FormControl>
                            <InputLabel>Name</InputLabel>
                            <Input type="text" name="contactNo" disabled defaultValue={name} />
                          </FormControl>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt">
                        <RHFTextField
                          id="outlined-basic"
                          name="contactNo"
                          label="Contact No"
                          variant="filled"
                          disabled
                          value=" "
                        />
                      </div>
                    );
                  })()}
                </div>
                <div>
                  {(() => {
                    if (department) {
                      return (
                        <div className="usrFrmFld">
                          <FormControl>
                            <InputLabel>Department</InputLabel>
                            <Input
                              type="text"
                              name="department"
                              defaultValue={department || ''}
                              disabled
                            />
                          </FormControl>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt">
                        <RHFTextField
                          id="outlined-basic"
                          name="department"
                          label="Department"
                          variant="filled"
                          disabled
                          value=" "
                        />
                      </div>
                    );
                  })()}
                </div>
                <div>
                  {(() => {
                    if (phnNo) {
                      return (
                        <div className="usrFrmFld">
                          <FormControl>
                            <InputLabel>Contact No</InputLabel>
                            <Input
                              type="text"
                              name="contactNo"
                              defaultValue={phnNo || ''}
                              disabled
                            />
                          </FormControl>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt">
                        <RHFTextField
                          id="outlined-basic"
                          name="contactNo"
                          label="Contact No"
                          variant="filled"
                          disabled
                          value=" "
                        />
                      </div>
                    );
                  })()}
                </div>
                {/* email */}
                <div>
                  {(() => {
                    if (email) {
                      return (
                        <div className="usrFrmFld">
                          <FormControl>
                            <InputLabel>Email</InputLabel>
                            <Input type="text" name="email" defaultValue={email || ''} disabled />
                          </FormControl>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt">
                        <RHFTextField
                          id="outlined-basic"
                          name="email"
                          label="Email"
                          variant="filled"
                          disabled
                          value=" "
                        />
                      </div>
                    );
                  })()}
                </div>
              </Box>
            </Card>
          </Grid>
          {console.log('userData', UserDt)}
          <Grid xs={12} md={7}>
            <Card sx={{ px: 3, pb: 5 }}>
              <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }} className='flex items-center gap-2'>
                <Iconify icon="grommet-icons:workshop" style={{ marginBottom: '-5px' }} /> Work
                Request Information
              </Typography>

              <Box display="flex" flexDirection="column" rowGap={3}>
                <RHFTextField
                  name="requestDate"
                  variant="filled"
                  label="Request Date"
                  disabled
                  inputProps={{ className: 'RejinputClass' }}
                  // value={UserDt[0]?.wkr_mst_org_date.date.split(' ')[0]}
                  // value={formatDate(UserDt[0]?.wkr_mst_org_date.date)}
                  value={
                    UserDt[0]?.wkr_mst_create_date.date
                      ? formatDate(UserDt[0]?.wkr_mst_create_date.date)
                      : ''
                  }
                />

                {/* work area */}
                <div className="usrFrmFld">
                  <FormControl>
                    <InputLabel>Work Area</InputLabel>
                    <Input type="text" value={FilledFormData?.workArea} disabled />
                  </FormControl>
                </div>
                {/* level */}
                <div className="usrFrmFld">
                  <FormControl>
                    <InputLabel>Level</InputLabel>
                    <Input
                      type="text"
                      name="wkr_mst_location"
                      value={FilledFormData?.level}
                      disabled
                    />
                  </FormControl>
                </div>

                {/* Asset Location */}
                <div className="usrFrmFld">
                  <FormControl>
                    <InputLabel>Asset Location</InputLabel>
                    <Input
                      type="text"
                      disabled
                      name="wkr_mst_assetlocn"
                      value={FilledFormData?.assetLocation}
                    />
                  </FormControl>
                </div>
                {/* Asset Number */}
                <div className="usrFrmFld">
                  <FormControl>
                    <InputLabel>Asset Number</InputLabel>
                    <Input type="text" name="wkr_mst_assetno" value={FilledFormData?.assetNumber} disabled />
                  </FormControl>
                </div>
                {/* work group */}
                <div className="usrFrmFld">
                  <FormControl>
                    <InputLabel>Work Group</InputLabel>
                    <Input
                      type="text"
                      name="wkr_mst_work_group"
                      disabled
                      value={FilledFormData?.workGroup}
                    />
                  </FormControl>
                </div>
                {/* Original Property */}

                
                {/* Faulty Code */}
                <div className="usrFrmFld">
                  <FormControl>
                    <InputLabel>Fault Code</InputLabel>
                    <Input
                      type="text"
                      name="wkr_mst_fault_code"
                      disabled
                      value={FilledFormData?.faultyCode}
                    />
                  </FormControl>
                </div>

                {/* <div className="disableBlack newbg">
                  <RHFTextField
                    name="wkr_mst_location_desc"
                    label="Request Description"
                    variant="filled"
                    multiline
                    rows={4}
                    value={FilledFormData?.workDescription}
                    disabled
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        // Target the root element of the outlined input
                        '& fieldset': {
                          // Target the fieldset element that defines the border
                          // border: 'none',
                        },
                      },
                    }}
                  />
                </div> */}

                  <div className='border border-black rounded-lg bg-[#edeff1] text-black' style={{padding:"4px 16px"}}>
                  <InputLabel style={{color:"black",fontSize:"13px",fontWeight:"500"}}>Request Description</InputLabel>
                  <textarea rows={4} className='bg-[#edeff1] text-[14px] w-full'    value={FilledFormData?.workDescription} disabled />

                  </div>


                    {/* Image Box */}
                
                <Grid
                  container
                  spacing={1}
                 
                >
                  {
                  UserDtImg &&
                  !imageError &&
                  UserDtImg.map((item)=>(
                    
                      <Grid item xs={3} 
                      
                      onClick={() =>
                        handleImageDialog(`${url}/${item.attachment}`, item.
                        file_name)
                      }
                      
                      
                      >
                      <Paper
                        elevation={3}
                        style={{ padding: 10, textAlign: 'center', height: 100, width: 100 }}
                      >
                        {console.log("attachment",UserDtImg)}
                        <img
                          src={`${url}/${item.attachment}`}
                          alt="yes"
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          onError={handleImageError}
                        />
                      </Paper>
                    </Grid>
                    ))
                  }
                </Grid>
              </Box>
            </Card>
            {/* Create Image grid */}

            <Card sx={{ px: 3, pb: 5 }} className="RejInfo">
              <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }} className='flex items-center gap-2'>
                <Iconify icon="ri:progress-5-line" style={{ marginBottom: '-5px' }} /> In Progress
                Information
              </Typography>
              <Box display="flex" flexDirection="column" rowGap={3}>
                <RHFTextField
                  name="Order Number"
                  variant="filled"
                  label="Work Order Number"
                  disabled
                  inputProps={{ className: 'RejinputClass' }}
                  value={FilledFormData?.workOrderNo}
                />

                <RHFTextField
                  name="OrderStatu"
                  variant="filled"
                  label="Work Order Status"
                  disabled
                  inputProps={{ className: 'RejinputClass' }}
                  value={FilledFormData?.workOrdeStatus}
                />

              {/* <div className="disableBlack newbg">
                  <RHFTextField
                 name="workcorr"
       
                    variant="filled"
                    label="Corrective Action"
                  disabled
                  className="wkoDetCorr"
                    multiline
                    rows={4}
                    value={FilledFormData?.workCorrective}
                
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        // Target the root element of the outlined input
                        '& fieldset': {
                          // Target the fieldset element that defines the border
                          // border: 'none',
                        },
                      },
                    }}
                  />
                </div> */}

                <div className='border border-black rounded-lg bg-[#edeff1] text-black' style={{padding:"4px 16px"}}>
                  <InputLabel style={{color:"black",fontSize:"13px",fontWeight:"500"}}>Corrective Action</InputLabel>
                  <textarea rows={4} className='bg-[#edeff1] text-[14px] w-full'     value={FilledFormData?.workCorrective} disabled />
                  </div>


              </Box>
            </Card>
            <Stack alignItems="inherit" sx={{ mt: 2 }}>
              {/* <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                    Save
              </LoadingButton> */}
            </Stack>
          </Grid>
        </Grid>
        {/* Dialog Image */}

        <Dialog
          open={imageDialog}
          onClose={() => setImageDialog(false)}
          fullWidth
          maxWidth="xs" // Adjust the maximum width for smaller screens
          PaperProps={{
            style: {
              maxHeight: '90vh', // Set maximum height to 80% of the viewport height
              overflowY: 'auto', // Enable vertical scrolling if content exceeds maxHeight
              padding: '20px',
            },
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '0 10px 0 10px',
            }}
          >
            <div
              style={{
                alignItems: 'center',
                gap: '2px',
                // Conditionally hide on small screens
                display: 'flex', // Initially hide
              }}
            >
              <DialogTitle id="alert-dialog-title" className="title">
                {imageData.head}
              </DialogTitle>
            </div>
            <RxCrossCircled
              size={28}
              style={{ color: 'red', cursor: 'pointer' }}
              onClick={() => setImageDialog(false)}
            />
          </div>
          <div style={{ flex: 1, overflow: 'hidden' }}>
            {/* Ensure proper filling */}
            <div
              style={{
                height: '50vh', // Subtract the height of the dialog header
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                src={imageData.ImageUrl}
                alt="imagePending"
                style={{ maxWidth: '100%', height: 'auto', objectFit: 'cover' }}
              />
            </div>
          </div>
        </Dialog>
      </FormProvider>
    </>
  );
}

InProgressStatus.propTypes = {
  selectedRowID: PropTypes.object,
};
